import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_2 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_3 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_4 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_5 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_6 = { class: "flex min-w-0 flex-col md:col-span-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Cập nhật thông tin dân cư" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("label", null, "Họ và tên", -1)),
            _createVNode(_component_InputText, {
              id: "username",
              type: "text",
              modelValue: $setup.customer.fullName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customer.fullName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Địa chỉ", -1)),
            _createVNode(_component_InputText, {
              id: "address",
              modelValue: $setup.customer.address,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customer.address) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Giới tính", -1)),
            _createVNode(_component_Dropdown, {
              id: "gender",
              modelValue: $setup.customer.gender,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.customer.gender) = $event)),
              options: $setup.genderList,
              optionLabel: "value",
              optionValue: "value",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Số điện thoại", -1)),
            _createVNode(_component_InputText, {
              id: "phoneNumber",
              type: "text",
              modelValue: $setup.customer.phoneNumber,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.customer.phoneNumber) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Tổ", -1)),
            _createVNode(_component_Dropdown, {
              id: "civilGroup",
              modelValue: $setup.customer.idCivilGroup,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.customer.idCivilGroup) = $event)),
              options: $setup.listCivilGroup,
              optionLabel: "civilGroupName",
              optionValue: "id",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_Button, {
          label: "Cập nhật",
          icon: "pi pi-sync",
          iconPos: "left",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.doUpdate())),
          class: "mr-[2vw] w-[15vw]"
        })
      ]),
      _: 1
    })
  ], 64))
}